import React, { useState, useCallback, useEffect } from 'react';
import { Container, Flex, Heading, HStack, IconButton } from '@chakra-ui/react';
import { SettingsIcon } from '@chakra-ui/icons';
import { useDispatch, useSelector } from 'react-redux';

import { getStoresListApi } from 'features/stores/stores.api';
import ItemsTable from './components/ItemsTable';
import SkuCatalogSyncSettingsModal from './components/SkuCatalogSyncSettingsModal';
import BulkActionsMenu from './components/BulkActionsMenu';
import ItemsExportButton from './components/ItemsExportButton';

const Items = () => {
  const dispatch = useDispatch();
  const [syncOpen, setSyncOpen] = useState(false);
  const [tableRefreshKey, setTableRefreshKey] = useState(0);
  const [exportQuery, setExportQuery] = useState({});
  const storesList = useSelector((s) => s.stores.list);

  useEffect(() => {
    dispatch(getStoresListApi());
  }, [dispatch]);

  const handleBulkCompleted = useCallback(() => {
    setTableRefreshKey((k) => k + 1);
  }, []);

  return (
    <Container maxW="container.2xl" py={8} mt="50px">
      <Flex justify="space-between" align="center" mb={6}>
        <Heading size="lg">Items</Heading>
        <HStack spacing={1}>
          <BulkActionsMenu storeOptions={storesList} onCompleted={handleBulkCompleted} />
          <ItemsExportButton exportQuery={exportQuery} />
          <IconButton
            aria-label="SKU management settings"
            icon={<SettingsIcon />}
            variant="ghost"
            onClick={() => setSyncOpen(true)}
          />
        </HStack>
      </Flex>
      <SkuCatalogSyncSettingsModal isOpen={syncOpen} onClose={() => setSyncOpen(false)} />
      <ItemsTable refreshKey={tableRefreshKey} onExportQueryChange={setExportQuery} />
    </Container>
  );
};

export default Items;
